module.exports = __webpack_public_path__ + "1793882494189/images/brandbook-half-o-bottom.16281ed.svg";